<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="ma_code,ma_prodcode,pr_detail,pr_orispeccode,ma_salecode,ma_custcode,ma_custname"
      placeholder="输入制造单号、客户、产品进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.ma_id"
        :to="'/production/make/'+item.ma_id"
      >
        <div class="weui-cell__bd">
          <p>{{item.ma_prdetail}}</p>
          <p class="list-item-muted">{{item.createTime}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.ma_code}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.ma_status!='已审核'}"
          >{{item.ma_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}张</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/make/make/list",
      filters: [
        {
          type: "date",
          name: "make.createTime"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              condition: "ma_tasktype='MAKE'"
            },
            {
              value: 1,
              label: "待领料",
              condition:
                "ma_tasktype='MAKE' and ifnull(ma_getstatus,' ') in(' ','部分领料')"
            },
            {
              value: 2,
              label: "待完工",
              condition:
                "ma_tasktype='MAKE' AND ifnull(ma_madeqty,0)>ma_qty and ma_statuscode='AUDITED'"
            },
            {
              value: 3,
              label: "已完工",
              condition: "ma_tasktype='MAKE' AND ifnull(ma_madeqty,0)>ma_qty"
            },
            {
              value: 4,
              label: "已结案",
              condition: "ma_tasktype='MAKE' AND ma_statuscode='FINISH'"
            }
          ]
        }
      ]
    };
  }
};
</script>